<template>
    <section class="view w-100">
        <Breadcrumb :breadcrumb="breadcrumb" v-if="current_path != '/change-password-after-days'"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text" v-if="current_path != '/change-password-after-days'">
                After you change your password, you will be redirected to the login page.
            </p>
            <p class="view__description__text" v-else>
                Since it's been {{password_expires_in ? password_expires_in : 'some'}} days since your last password change, we kindly ask you to update it now before proceeding with any actions in the digital solutions system.
            </p>
        </div>
        <div class="tab-content">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mt-4">
                    <div class="col-lg-8 col-sm-12 mx-auto">
                        <v-card class="d-flex justify-content-center">
                            <form @submit.prevent="resetPassword()" class="w-80 p-4 p-md-0 p-lg-0 ">
                                <h3 class="text-center p-auth mt-0 mt-md-4 mt-lg-4"><b>Your new password must pass the following validations</b></h3>
                                <ul class="list-group mb-4">
                                    <li class="p-auth">
                                        <div class="text-left mb-2"> 
                                            <button class="btn-sm btn-primary icon-pass-neutro" v-if="!password.length" disabled>
                                                <i class="icon-info"/>
                                            </button>
                                            <button class="btn-sm btn-primary" :class="validateLength() ? 'icon-pass-success' : 'icon-pass-warning'" v-else>
                                                <i :class="validateLength() ? 'icon-check' : 'icon-close'" />
                                            </button>
                                            At least 8 characters long
                                        </div>
                                    </li>
                                    <li class="text-left mb-2 p-auth">
                                        <button class="btn-sm btn-primary icon-pass-neutro" v-if="!password.length" disabled>
                                                <i class="icon-info"/>
                                        </button>
                                        <button  class="btn-sm btn-primary" :class="validateUpperCaseLetter() ? 'icon-pass-success' : 'icon-pass-warning'" v-else>
                                            <i :class="validateUpperCaseLetter() ? 'icon-check' : 'icon-close'"></i>
                                        </button>
                                            At least one upper-case letter
                                    </li>
                                    <li class="text-left mb-2  p-auth">
                                        <div class="mr-0">
                                        <button class="btn-sm btn-primary icon-pass-neutro" v-if="!password.length" disabled>
                                                <i class="icon-info"/>
                                        </button>
                                        <button  class="btn-sm btn-primary" :class="validateSpecialCharacters() ? 'icon-pass-success' : 'icon-pass-warning'" v-else>
                                                <i :class="validateSpecialCharacters() ? 'icon-check' : 'icon-close'" />
                                            </button>
                                            At least one special character
                                            
                                        </div>
                                    </li>

                                </ul>
                                <div class="row">
                                    <div class="col-md-6 mx-auto">
                                        <div class="text-left login__input">
                                            <img src="/assets/img/pass.png" alt="Icon password" class="login__input__icon"/>
                                            <label for="current_password">Current password</label>
                                            <input type="password" class="login__input__field" id="current_password"  placeholder="Enter password" v-model="current_password" autocomplete="off">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="text-left login__input">
                                            <img src="/assets/img/pass.png" alt="Icon password" class="login__input__icon"/>
                                            <label for="password">Password</label>
                                            <input type="password" class="login__input__field" id="password"  placeholder="Enter password" v-model="password" autocomplete="off">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="text-left login__input">
                                        <img src="/assets/img/pass.png" alt="Icon password" class="login__input__icon"/>
                                            <label for="confirm_password">Confirm password</label>
                                            <input type="password" class="login__input__field" id="confirm_password" placeholder="Confirm password" v-model="confirm_password">
                                            <div class="red-text" data-error="wrong" data-success="right" v-html="`Passwords do not match`" v-if="confirm_password.length && validateConfirmPassword()"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center">
                                    <button style="width: 8rem" class="modal__buttons__item  mb-3" :disabled="validateLength() && validateUpperCaseLetter() && validateSpecialCharacters() && !validateConfirmPassword() ? false:true"  v-if="!is_loading">
                                        Submit
                                    </button>
                                    <button v-else type="button" style="width: 8rem" class="modal__buttons__item mb-3 p-2" :disabled="validateLength() && validateUpperCaseLetter() && validateSpecialCharacters() && !validateConfirmPassword() ? false:true">
                                        <div class="spinner-border" role="status">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                    </button>
                                </div>
                            </form>
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>
<script>
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import Resources from './resources'

export default {
    name: 'ChangePassword',

    components: {
        Breadcrumb
    },

    data()
    {
        return {
            title_page: 'Change Password',
            breadcrumb: Resources.breadcrumb,
            rest_api: 'associates_change_password',
            password: '',
            confirm_password: '',
            current_password: '',
            current_path: this.$route.path,
            is_loading: false,
            password_expires_in: ''
        }
    },

    methods: 
    {
        async resetPassword()
        {

            this.is_loading = true

            if(!this.current_password)
            {
                this.notyfMesg('The current password is required', 'error')
                this.is_loading = false
                return
            }
            const form_data = {
                current_password: this.current_password,
                password: this.password,
                password_confirmation: this.confirm_password
            }

            const response = await this.post(`${this.rest_api}`, form_data)

            this.is_loading = false

            if(response.status)
            {
                this.notyfMesg('Password saved')
                localStorage.removeItem('access_token')
                window.location.href = '/'

            }
            else
            {
                this.error_handling(response)
            }

        },
        validateLength()
        {
            if(this.password.length >= 8)
            {
                return true
            }
            else
            {
                return false
            }

        },
        validateUpperCaseLetter()
        {
            let password = this.password.split('')
            for (var i = 0; i < password.length; i++) 
            {
                let letter = password[i]
                
                //eslint-disable-next-line
                const format = /[A-Za-z]/;
                if((format).test(letter))
                {
                    if (letter.toUpperCase() === letter) 
                    {
                        return true;
                    } 
                }
            }
           
        },
        validateSpecialCharacters()
        {
            //eslint-disable-next-line
            const format = /[ `!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?¿~¨´°¬]/;
            if((format).test(this.password))
            {
                return true
            }
            else
            {
                return false
            }

        },
        validateConfirmPassword()
        {
            if(this.password === this.confirm_password)
            {
                return false
            }
            else
            {
                return true
            }
        },
    },

    mounted()
    {
        const user = JSON.parse(localStorage.getItem('user'))
        console.log(user);
        this.password_expires_in = user ? user.password_expires_in : ''
        console.log(this.$route.path)
    }
}
</script>